import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import Select from 'react-select';
import { Boundary, Mission } from '../../../db';

interface holeMergeWithOption {
  label: string;
  value: string;
}

interface DialogProps {
  open: boolean;
  mission: Mission;
  boundaryId: number;
  onClose: () => void;
  onMergeClick: (selectedBoundaryId: number, mergeWithBoundaryId: number) => void;
}

const HolesMergeDialog: React.FC<DialogProps> = ({ open, mission, boundaryId, onClose, onMergeClick }) => {
  const selectedBoundary = mission.getInnerBoundaryById(boundaryId);

  const mergeWithOptions =
    selectedBoundary
      ?.getInnerZone()
      ?.getInnerZoneBoundarys()
      .map((hole, index) => {
        if (hole.instance_id === boundaryId) {
          return false;
        }

        const holeLabel = Boundary.holeLabel(hole.poly_id, index);

        return {
          label: `Hole ${holeLabel}`,
          value: hole.instance_id.toString(),
        };
      })
      .filter((option) => option !== false) || [];

  const [holeToMergeWith, setHoleToMergeWith] = useState<holeMergeWithOption | null>(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          minHeight: '200px',
          minWidth: '300px',
          height: 'auto',
        },
      }}
    >
      <DialogTitle>{selectedBoundary ? `Merge hole with` : 'No Boundary Selected'}</DialogTitle>

      <DialogContent dividers style={{ minHeight: '150px', paddingBottom: '20px' }}>
        <Select
          value={holeToMergeWith}
          onChange={(option) => setHoleToMergeWith(option as holeMergeWithOption)}
          options={mergeWithOptions}
          isSearchable
          placeholder="Choose a hole......"
          menuPortalTarget={document.body}
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button
          disabled={!holeToMergeWith}
          onClick={() => {
            if (!selectedBoundary || !holeToMergeWith || !holeToMergeWith.value) {
              return;
            }

            onMergeClick(boundaryId, Number(holeToMergeWith.value));
          }}
          color="primary"
          variant="outlined"
        >
          Merge
        </Button>

        <Button onClick={onClose} color="secondary" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HolesMergeDialog;
